import React from "react";
import EmployeePosition from "components/Tvendo/Distribution/DataMaster/EmployeePosition/List";

export default function () {
  return <EmployeePosition />;
}
